// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MinisteriosPage.module.css */

.Ministerios_ministeriosPage__C8yb8 {
    min-height: 100vh;
    background-color: #ffffff;
}

.Ministerios_heroSection__VheY- {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    padding: 2rem 0;
}

.Ministerios_heroImageContainer__c9HBF {
    width: 50%;
}

.Ministerios_heroImage__2RmnB {
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin-top: 40px;
}

.Ministerios_heroContentContainer__sDTQj {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 2rem;
}

.Ministerios_heroContent__Dg7ZZ {
    margin-bottom: 2rem;
}

.Ministerios_heroTitle__szME9 {
    font-family: "Space Grotesk", sans-serif;
    font-optical-sizing: auto;
    font-weight: 700;
    font-style: normal;
    font-size: 3.4rem;
    color: #1e1e1e;
    margin-bottom: 0.5rem;
    text-align: center;
}

.Ministerios_heroSubtitle__7rOPL {
    font-size: 1rem;
    color: #1e1e1e;
    text-align: center;
}

.Ministerios_carouselContainer__zWwwR {
    position: relative;
}

.Ministerios_carouselControls__pNMvg {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 1rem;
}

.Ministerios_arrowButton__5cNBX {
    background-color: #1e1e1e;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    font-size: 1.5rem;
    cursor: pointer;
    z-index: 10;
    border-radius: 10%;
    margin-right: 20px;
}

.Ministerios_carousel__Kxtis {
    display: flex;
    gap: 1.5rem;
    transition: transform 0.5s ease;
}

.Ministerios_card__joJVP {
    position: relative;
    background-color: #fff;
    border-radius: 0.75rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    width: 250px;
    height: 350px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    transition: all 0.3s;
}

.Ministerios_card__joJVP:hover {
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-4px);
}

.Ministerios_cardTopBorder__XIm6m {
    height: 0.5rem;
    width: 100%;
}

.Ministerios_bgBlue__bC\\+7I {
    background-color: #3b83f649;
}

.Ministerios_bgPurple__migSB {
    background-color: #2fe8c93f;
}

.Ministerios_bgRed__WbSj2 {
    background-color: #f2cc726e;
}

.Ministerios_bgPink__JB1LL {
    background-color: #ec489a62;
}

.Ministerios_bgGreen__NSaKt {
    background-color: #1059b958;
}

.Ministerios_bgOrange__1\\+GTB {
    background-color: #008cff4a;
}

.Ministerios_bgYellow__w9YIT {
    background-color: #ff000047;
}

.Ministerios_bgIndigo__IYaiE {
    background-color: #ff9d0041;
}

.Ministerios_cardContent__4hs2u {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: top;
    align-items: top;
    height: 100%;
}

.Ministerios_iconContainer__DANhF {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
}

.Ministerios_icon__cLhmt {
    width: 6rem;
    height: 6rem;
    position: relative;
}

.Ministerios_iconImage__XdFZX {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.Ministerios_cardTextContent__8U9eq {
    text-align: center;
}

.Ministerios_cardTitle__RQQ0U {
    font-size: 1rem;
    font-weight: bold;
    color: #1f2937;
    margin-bottom: 0.25rem;
}

.Ministerios_cardSubtitle__gP\\+-Z {
    font-size: 0.75rem;
    color: #6b7280;
    margin-bottom: 0.75rem;
}

.Ministerios_description__yBs6Y {
    text-align: left;
}

.Ministerios_descriptionText__nwjT5 {
    font-size: 0.875rem;
    color: #4b5563;
}

/* Responsividade */
@media (max-width: 768px) {
    .Ministerios_heroSection__VheY- {
        flex-direction: column;
    }

    .Ministerios_heroImageContainer__c9HBF,
    .Ministerios_heroContentContainer__sDTQj {
        width: 100%;
    }

    .Ministerios_heroImageContainer__c9HBF {
        order: 1;
    }

    .Ministerios_heroContentContainer__sDTQj {
        order: 2;
        width: 85vw;
    }

    .Ministerios_carousel__Kxtis {
        display: flex;
        gap: 1.5rem;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 1rem;
        /* Adiciona espaço inferior para os botões */
    }

    .Ministerios_card__joJVP {
        flex: 0 0 80%;
        scroll-snap-align: start;
    }

    .Ministerios_heroTitle__szME9 {
        font-size: 1.8rem;
        /* Reduz o tamanho da fonte do título */
        text-align: left;
        /* Alinha o título à esquerda */
        margin-bottom: 0.75rem;
        /* Aumenta o espaçamento inferior do título */
    }

    .Ministerios_heroSubtitle__7rOPL {
        font-size: 0.9rem;
        /* Reduz o tamanho da fonte do subtítulo */
        text-align: left;
        /* Alinha o subtítulo à esquerda */
    }

    .Ministerios_cardTitle__RQQ0U {
        font-size: 0.9rem;
        /* Reduz o tamanho da fonte do título do card */
    }

    .Ministerios_cardSubtitle__gP\\+-Z {
        font-size: 0.7rem;
        /* Reduz o tamanho da fonte do subtítulo do card */
    }

    .Ministerios_descriptionText__nwjT5 {
        font-size: 0.8rem;
        /* Reduz o tamanho da fonte da descrição */
    }

    .Ministerios_carouselControls__pNMvg {
        justify-content: center;
        margin-top: 1rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Site/Ministerios/Ministerios.module.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,wCAAwC;IACxC,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,0CAA0C;IAC1C,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,QAAQ;QACR,WAAW;IACf;;IAEA;QACI,aAAa;QACb,WAAW;QACX,gBAAgB;QAChB,6BAA6B;QAC7B,iCAAiC;QACjC,oBAAoB;QACpB,4CAA4C;IAChD;;IAEA;QACI,aAAa;QACb,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;QACjB,uCAAuC;QACvC,gBAAgB;QAChB,+BAA+B;QAC/B,sBAAsB;QACtB,6CAA6C;IACjD;;IAEA;QACI,iBAAiB;QACjB,0CAA0C;QAC1C,gBAAgB;QAChB,kCAAkC;IACtC;;IAEA;QACI,iBAAiB;QACjB,+CAA+C;IACnD;;IAEA;QACI,iBAAiB;QACjB,kDAAkD;IACtD;;IAEA;QACI,iBAAiB;QACjB,0CAA0C;IAC9C;;IAEA;QACI,uBAAuB;QACvB,gBAAgB;IACpB;AACJ","sourcesContent":["/* MinisteriosPage.module.css */\r\n\r\n.ministeriosPage {\r\n    min-height: 100vh;\r\n    background-color: #ffffff;\r\n}\r\n\r\n.heroSection {\r\n    display: flex;\r\n    align-items: stretch;\r\n    justify-content: space-between;\r\n    padding: 2rem 0;\r\n}\r\n\r\n.heroImageContainer {\r\n    width: 50%;\r\n}\r\n\r\n.heroImage {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    margin-top: 40px;\r\n}\r\n\r\n.heroContentContainer {\r\n    width: 50%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    padding: 2rem;\r\n}\r\n\r\n.heroContent {\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.heroTitle {\r\n    font-family: \"Space Grotesk\", sans-serif;\r\n    font-optical-sizing: auto;\r\n    font-weight: 700;\r\n    font-style: normal;\r\n    font-size: 3.4rem;\r\n    color: #1e1e1e;\r\n    margin-bottom: 0.5rem;\r\n    text-align: center;\r\n}\r\n\r\n.heroSubtitle {\r\n    font-size: 1rem;\r\n    color: #1e1e1e;\r\n    text-align: center;\r\n}\r\n\r\n.carouselContainer {\r\n    position: relative;\r\n}\r\n\r\n.carouselControls {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.arrowButton {\r\n    background-color: #1e1e1e;\r\n    color: white;\r\n    border: none;\r\n    padding: 0.5rem 1rem;\r\n    font-size: 1.5rem;\r\n    cursor: pointer;\r\n    z-index: 10;\r\n    border-radius: 10%;\r\n    margin-right: 20px;\r\n}\r\n\r\n.carousel {\r\n    display: flex;\r\n    gap: 1.5rem;\r\n    transition: transform 0.5s ease;\r\n}\r\n\r\n.card {\r\n    position: relative;\r\n    background-color: #fff;\r\n    border-radius: 0.75rem;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n    overflow: hidden;\r\n    width: 250px;\r\n    height: 350px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    text-align: center;\r\n    transition: all 0.3s;\r\n}\r\n\r\n.card:hover {\r\n    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15);\r\n    transform: translateY(-4px);\r\n}\r\n\r\n.cardTopBorder {\r\n    height: 0.5rem;\r\n    width: 100%;\r\n}\r\n\r\n.bgBlue {\r\n    background-color: #3b83f649;\r\n}\r\n\r\n.bgPurple {\r\n    background-color: #2fe8c93f;\r\n}\r\n\r\n.bgRed {\r\n    background-color: #f2cc726e;\r\n}\r\n\r\n.bgPink {\r\n    background-color: #ec489a62;\r\n}\r\n\r\n.bgGreen {\r\n    background-color: #1059b958;\r\n}\r\n\r\n.bgOrange {\r\n    background-color: #008cff4a;\r\n}\r\n\r\n.bgYellow {\r\n    background-color: #ff000047;\r\n}\r\n\r\n.bgIndigo {\r\n    background-color: #ff9d0041;\r\n}\r\n\r\n.cardContent {\r\n    padding: 1rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: top;\r\n    align-items: top;\r\n    height: 100%;\r\n}\r\n\r\n.iconContainer {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.icon {\r\n    width: 6rem;\r\n    height: 6rem;\r\n    position: relative;\r\n}\r\n\r\n.iconImage {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: contain;\r\n}\r\n\r\n.cardTextContent {\r\n    text-align: center;\r\n}\r\n\r\n.cardTitle {\r\n    font-size: 1rem;\r\n    font-weight: bold;\r\n    color: #1f2937;\r\n    margin-bottom: 0.25rem;\r\n}\r\n\r\n.cardSubtitle {\r\n    font-size: 0.75rem;\r\n    color: #6b7280;\r\n    margin-bottom: 0.75rem;\r\n}\r\n\r\n.description {\r\n    text-align: left;\r\n}\r\n\r\n.descriptionText {\r\n    font-size: 0.875rem;\r\n    color: #4b5563;\r\n}\r\n\r\n/* Responsividade */\r\n@media (max-width: 768px) {\r\n    .heroSection {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .heroImageContainer,\r\n    .heroContentContainer {\r\n        width: 100%;\r\n    }\r\n\r\n    .heroImageContainer {\r\n        order: 1;\r\n    }\r\n\r\n    .heroContentContainer {\r\n        order: 2;\r\n        width: 85vw;\r\n    }\r\n\r\n    .carousel {\r\n        display: flex;\r\n        gap: 1.5rem;\r\n        overflow-x: auto;\r\n        scroll-snap-type: x mandatory;\r\n        -webkit-overflow-scrolling: touch;\r\n        padding-bottom: 1rem;\r\n        /* Adiciona espaço inferior para os botões */\r\n    }\r\n\r\n    .card {\r\n        flex: 0 0 80%;\r\n        scroll-snap-align: start;\r\n    }\r\n\r\n    .heroTitle {\r\n        font-size: 1.8rem;\r\n        /* Reduz o tamanho da fonte do título */\r\n        text-align: left;\r\n        /* Alinha o título à esquerda */\r\n        margin-bottom: 0.75rem;\r\n        /* Aumenta o espaçamento inferior do título */\r\n    }\r\n\r\n    .heroSubtitle {\r\n        font-size: 0.9rem;\r\n        /* Reduz o tamanho da fonte do subtítulo */\r\n        text-align: left;\r\n        /* Alinha o subtítulo à esquerda */\r\n    }\r\n\r\n    .cardTitle {\r\n        font-size: 0.9rem;\r\n        /* Reduz o tamanho da fonte do título do card */\r\n    }\r\n\r\n    .cardSubtitle {\r\n        font-size: 0.7rem;\r\n        /* Reduz o tamanho da fonte do subtítulo do card */\r\n    }\r\n\r\n    .descriptionText {\r\n        font-size: 0.8rem;\r\n        /* Reduz o tamanho da fonte da descrição */\r\n    }\r\n\r\n    .carouselControls {\r\n        justify-content: center;\r\n        margin-top: 1rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ministeriosPage": `Ministerios_ministeriosPage__C8yb8`,
	"heroSection": `Ministerios_heroSection__VheY-`,
	"heroImageContainer": `Ministerios_heroImageContainer__c9HBF`,
	"heroImage": `Ministerios_heroImage__2RmnB`,
	"heroContentContainer": `Ministerios_heroContentContainer__sDTQj`,
	"heroContent": `Ministerios_heroContent__Dg7ZZ`,
	"heroTitle": `Ministerios_heroTitle__szME9`,
	"heroSubtitle": `Ministerios_heroSubtitle__7rOPL`,
	"carouselContainer": `Ministerios_carouselContainer__zWwwR`,
	"carouselControls": `Ministerios_carouselControls__pNMvg`,
	"arrowButton": `Ministerios_arrowButton__5cNBX`,
	"carousel": `Ministerios_carousel__Kxtis`,
	"card": `Ministerios_card__joJVP`,
	"cardTopBorder": `Ministerios_cardTopBorder__XIm6m`,
	"bgBlue": `Ministerios_bgBlue__bC+7I`,
	"bgPurple": `Ministerios_bgPurple__migSB`,
	"bgRed": `Ministerios_bgRed__WbSj2`,
	"bgPink": `Ministerios_bgPink__JB1LL`,
	"bgGreen": `Ministerios_bgGreen__NSaKt`,
	"bgOrange": `Ministerios_bgOrange__1+GTB`,
	"bgYellow": `Ministerios_bgYellow__w9YIT`,
	"bgIndigo": `Ministerios_bgIndigo__IYaiE`,
	"cardContent": `Ministerios_cardContent__4hs2u`,
	"iconContainer": `Ministerios_iconContainer__DANhF`,
	"icon": `Ministerios_icon__cLhmt`,
	"iconImage": `Ministerios_iconImage__XdFZX`,
	"cardTextContent": `Ministerios_cardTextContent__8U9eq`,
	"cardTitle": `Ministerios_cardTitle__RQQ0U`,
	"cardSubtitle": `Ministerios_cardSubtitle__gP+-Z`,
	"description": `Ministerios_description__yBs6Y`,
	"descriptionText": `Ministerios_descriptionText__nwjT5`
};
export default ___CSS_LOADER_EXPORT___;
